import { Component, TemplateRef, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent {
  modalRef: BsModalRef;
  message: string;
  customMessage: string; // Messaggio personalizzabile
  idForDelete: number;
  
  @Output()
  dialogOutput: EventEmitter<Number> = new EventEmitter<Number>();

  @ViewChild('templateref') public templateref: TemplateRef<any>;
  constructor(private modalService: BsModalService) {}

  // Overload del metodo openModal per supportare messaggio opzionale
  openModal(id: number): void;
  openModal(id: number, customMessage: string): void;
  openModal(id: number, customMessage?: string): void {
    this.idForDelete = id;
    this.customMessage = customMessage;
    this.modalRef = this.modalService.show(this.templateref, { class: 'modal-sm' });
  }

  confirm(): void {
    this.message = 'Confirmed!';
    this.modalRef.hide();
    this.dialogOutput.emit(this.idForDelete);
  }

  decline(): void {
    this.message = 'Declined!';
    this.modalRef.hide();
    this.dialogOutput.emit(-1);
  }
}

export class ModelComponentData {
  action: string;
  id: number;
}